import { Injector, ReflectiveInjector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityTypeFactory, AppContext, AppContextManager, IViewContext } from '@farris/devkit';
import { BE_SERVER_URI_TOKEN, DynamicBefRepository } from '@farris/bef';
import { MetadataService } from '../service/metadata.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

export class RenderAppContextBuilder {

  private entityTypeFactory: EntityTypeFactory;

  private metadataService: MetadataService;

  constructor(private httpClient: HttpClient, private injector: Injector, private router: Router) {
    this.entityTypeFactory = new EntityTypeFactory();
    this.metadataService = new MetadataService(this.httpClient, this.injector);
  }

  public create(): Observable<AppContext> {
    const $result = new Subject<AppContext>();
    this.metadataService.getRelatedMetadatas()
      .subscribe((metadatas: Map<string, any>) => {
        const appContext = new AppContext(this.injector, new AppContextManager(), null);
        this.initializeRenderAppContext(appContext, metadatas);
        $result.next(appContext);
      });
    return $result;
  }

  public createByFormMetadataContent(metadataContent: any): Observable<AppContext> {
    const $result = new Subject<AppContext>();
    this.metadataService.getRelatedMetadatasByFormMetadata(metadataContent)
      .subscribe((metadatas: Map<string, any>) => {
        const appContext = new AppContext(this.injector, new AppContextManager(), null);
        this.initializeRenderAppContext(appContext, metadatas);
        $result.next(appContext);
      });
    return $result;
  }

  public attach(appContext: AppContext, metadataContent: any): Observable<AppContext> {
    const $result = new Subject<AppContext>();
    this.metadataService.getRelatedMetadatasByFormMetadata(metadataContent).subscribe((metadatas: Map<string, any>) => {
      this.initializeRenderAppContext(appContext, metadatas);
      $result.next(appContext);
    });
    return $result;
  }

  public attachAsync(appContext: AppContext, route: ActivatedRoute, defaultMetadataContent: any): Observable<AppContext> {
    const $result = new Subject<AppContext>();
    appContext = appContext || new AppContext(this.injector, new AppContextManager(), null);
    this.metadataService.getMetadatas(route, defaultMetadataContent).subscribe((metadatas: Map<string, any>) => {
      this.initializeRenderAppContext(appContext, metadatas);
      $result.next(appContext);
    });
    return $result;
  }

  private initializeRenderAppContext(appContext: AppContext, metadatas: Map<string, any>) {
    const formMetadataContent = metadatas.get('formMetadataContent');
    const controllers = metadatas.get('commandControllers');
    const stateMachineMetadataContent = metadatas.get('stateMachineMetadataContent');
    const repositoryProviders = [
      { provide: AppContext, useValue: appContext },
      {
        provide: BE_SERVER_URI_TOKEN,
        useFactory() {
          return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        }
      }
    ];
    const reposotoryInjector = ReflectiveInjector.resolveAndCreate(repositoryProviders, this.injector);
    const formModule = formMetadataContent.module;
    const repositoryName = `${formModule.code}Repository`;
    const schema = formModule.schemas[0];
    const EntityType = this.entityTypeFactory.create(schema);
    const serviceUri = schema.sourceUri.toLowerCase();
    // const repository = new DynamicBefRepository(reposotoryInjector, repositoryName, EntityType, '', serviceUri);
    if (!appContext.repository) {
      appContext.repository = new DynamicBefRepository(reposotoryInjector, repositoryName, EntityType, '', serviceUri);
    }
    appContext.router = this.router;
    appContext.initializeByMetadata(formMetadataContent, stateMachineMetadataContent, controllers);
  }
}
